import { CSSProperties } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { useChartContext } from '../chart.provider';
import { CategoryBarChartProps } from './category-bar-chart-types';
import { GroupName } from './group-name';

interface Props {
  groupNames: string[];
  highestValueConfig?: CategoryBarChartProps['highestValueConfig'];
  highestValueGroup?: string;
  showXAxis?: boolean;
  style?: CSSProperties;
  customGroupNameRenderer?: CategoryBarChartProps['customGroupNameRenderer'];
}

export const Groups = ({
  customGroupNameRenderer,
  groupNames = [],
  highestValueConfig,
  highestValueGroup,
  showXAxis,
  style,
}: Props) => {
  const { labels } = useChartContext();

  return (
    <div
      css={styles.wrapper}
      style={{
        marginBottom: showXAxis ? theme.spacing(4) : 0,
        ...style,
      }}
    >
      {groupNames.map((name) =>
        typeof customGroupNameRenderer === 'function' ? (
          <div key={name}>{customGroupNameRenderer({ groupName: name })}</div>
        ) : (
          <GroupName
            key={name}
            highestValueColor={highestValueConfig?.color}
            highestValueIconName={highestValueConfig?.iconName}
            highestValueText={highestValueGroup === name ? highestValueConfig?.text : null}
            title={labels?.[name] ?? name}
          />
        )
      )}
    </div>
  );
};

const styles = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-around;
    transition: margin-top 0.2s;
  `,
};
